import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";

// Owner switch: the customer's very next monthly bill is $0.00, then regular billing resumes. Emails the customer on and off.
export const FreeMonthControl = ({ c, busy, run }) => {
  const d = c.discount;
  const mine = d && d.kind === "free_month";
  const on = mine && ["scheduled", "applied"].includes(d.status);
  const used = mine && d.status === "used";
  const who = c.shop_name || c.email;
  const toggle = () => {
    if (on) run("free-month", () => api.adminDiscountCancel(c.id).then((r) => ({ ...c, ...r })), `Free month removed — ${who} will be charged the regular price and has been emailed`);
    else run("free-month", () => api.adminFreeMonth(c.id).then((r) => ({ ...c, ...r })), `Next month is free for ${who} — they've been emailed "Your next month of Xpattern is on us"`);
  };
  return (
    <span className="flex flex-wrap items-center gap-1.5" data-testid={`free-month-${c.id}`}>
      <button type="button" role="switch" aria-checked={on} disabled={Boolean(busy)} data-testid={`free-month-toggle-${c.id}`} onClick={toggle}
        title={on ? `Switch off to charge the regular price on ${d.month_label}` : "Switch on: their next bill is $0.00, then regular billing resumes. Emails the customer."}
        className={`glass-btn flex items-center gap-1.5 px-2.5 py-1 text-[11px] ${on ? "text-[#3ecf8e]" : "text-[#e8e9ec]"}`}>
        {busy === "free-month" ? <Loader2 className="h-3 w-3 animate-spin" /> : <span className={`relative inline-flex h-3.5 w-6 shrink-0 rounded-full transition-colors ${on ? "bg-[#3ecf8e]" : "bg-[#3a4356]"}`}><span className={`absolute top-0.5 h-2.5 w-2.5 rounded-full bg-white transition-transform ${on ? "translate-x-3" : "translate-x-0.5"}`} /></span>}
        <Gift className="h-3 w-3" /> Next month free
      </button>
      {on && <span className="text-[10.5px] text-[#3ecf8e]" data-testid={`free-month-status-${c.id}`}>{d.month_label} bill · $0.00</span>}
      {used && <span className="text-[10.5px] text-[#9aa0a8]" data-testid={`free-month-used-${c.id}`}>Free month used · {d.month_label}</span>}
    </span>
  );
};
